import styles from "./style.module.css";
import React from "react";

interface IButton {
  text: string;
  onClick: () => void;
  color: string;
}

export default function ButtonModal({
  title,
  sub,
  oneButton,
  twoRightButton,
}: {
  title: string;
  sub: string;
  oneButton: IButton;
  twoRightButton?: IButton;
}) {
  const handleButtonClick =
    (buttonClickHandler: () => void) => (e: React.MouseEvent) => {
      e.stopPropagation();
      buttonClickHandler();
    };

  return (
    <div className={styles.modalStyle}>
      <div style={{ width: "100%", padding: "24px", paddingTop: "32px" }}>
        <p className={styles.textStyle}>{title}</p>
        <p
          style={{
            lineHeight: "25px",
            textAlign: "center",
            whiteSpace: "pre-line",
          }}
        >
          {sub}
        </p>
      </div>
      <div style={{ width: "300px", height: "48px", display: "flex" }}>
        <button
          onClick={handleButtonClick(oneButton.onClick)}
          style={{
            flex: 1,
            backgroundColor: oneButton.color,
            color: "white",
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          {oneButton.text}
        </button>
        {twoRightButton && (
          <button
            onClick={handleButtonClick(twoRightButton.onClick)}
            style={{
              flex: 1,
              backgroundColor: twoRightButton.color,
              color: "white",
              fontSize: "16px",
              fontWeight: 500,
            }}
          >
            {twoRightButton.text}
          </button>
        )}
      </div>
    </div>
  );
}
